const environments = {
  development: {
    API_URL: `http://localhost:5000`,
    CACHE_TTL: 3600000,
  },
  production: {
    API_URL: process.env.REACT_APP_API_URL,
    CACHE_TTL: 7200000,
  }
};

export const config = environments[process.env.NODE_ENV || 'development']
export const WEATHER_API_KEY = process.env.REACT_APP_WEATHER_API_KEY
